/*
 * File: /src/components/modals/modals-content/ModalNewCustomObject.1.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 21st September 2018 11:55:35 am
 * Last Modified: Friday, 21st September 2018 1:30:50 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" :class="className" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title modal-field__title--warning" v-html="title"></h1>
    <p class="modal-field__content">You are about to import new data which will result in deleting everything you had till now.</p>

    <div class="modal-field__buttons">
      <BaseButton title="Cancel importing" @click.native="closeModal" theme="cancel" :disabled="loading"/>
      <BaseButton title="Import and delete current data" @click.native="handleSubmit" :loading="loading" theme="primary"/>
    </div>
  </div>
</template>

<script>
  import { FileUploadHelper } from '@/helpers'

  export default {
    data () {
      return {
        title: 'Warning!',
        form: null,
        loading: false
      }
    },
    computed: {
      className () {
        return (this.loading)? 'modal-field__close-btn--disabled' : ''
      }
    },
    methods: {
      closeModal () {
        if (this.loading) {
          return
        }
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      async handleSubmit () {
        try {
          let content = await FileUploadHelper()
          this.loading = true
          let result = await this.$store.dispatch('shopifyApi/SCHEMA_IMPORT', { content })

          this.$store.commit('banners/SHOW_BANNER', {
            status: 'success',
            title: 'Fields Schema imported.'
          })

          this.loading = false
          this.closeModal()
        } catch (error) {
          console.error(error)
        }
      },
      collectForm (form) {
        this.form = form
      }
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>
<style>
.modal-field__close-btn--disabled {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalImportWarning.vue